export const CONFIG = {
  FRONTEND_ORIGIN: process.env.REACT_APP_FRONTEND_ORIGIN,
  BACKEND_ORIGIN: process.env.REACT_APP_BACKEND_ORIGIN,
};